module.exports = {"220183001":"胜利街道","220183002":"建设街道","220183003":"惠发街道","220183004":"夏家店街道","220183100":"大青嘴镇","220183101":"郭家镇","220183102":"松花江镇","220183103":"达家沟镇","220183104":"大房身镇","220183105":"岔路口镇","220183106":"朱城子镇","220183107":"布海镇","220183108":"天台镇","220183109":"菜园子镇","220183200":"同太乡","220183201":"边岗乡","220183202":"五台乡","220183203":"朝阳乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220183.json
// module id = 616
// module chunks = 0